import { supabase } from "../supabaseClient";

const rawApiBaseUrl = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL || "";
const apiBaseUrl = rawApiBaseUrl.trim().replace(/\/+$/, "") || (typeof window !== "undefined" ? window.location.origin : "");

const getToken = async () => {
  const { data: { session }, error } = await supabase.auth.getSession();
  if (error || !session?.access_token) throw new Error(error?.message || "Please sign in first.");
  return session.access_token;
};

const request = async (path, options = {}) => {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    headers: { Accept: "application/json", ...(options.body ? { "Content-Type": "application/json" } : {}), ...(options.auth ? { Authorization: `Bearer ${await getToken()}` } : {}) },
  });
  const payload = await response.json().catch(() => null);
  if (!response.ok || payload?.status === "error") throw new Error(payload?.message || "Review request failed.");
  return payload;
};

export const loadPublishedReviews = async () => (await request("/api/reviews")).reviews || [];
export const submitReview = async (review) => (await request("/api/reviews", { method: "POST", auth: true, body: JSON.stringify(review) })).review;
export const loadAdminReviews = async () => (await request("/api/admin/reviews", { auth: true })).reviews || [];
export const updateAdminReview = async (id, updates) => (await request(`/api/admin/reviews/${id}`, { method: "PATCH", auth: true, body: JSON.stringify(updates) })).review;
export const deleteAdminReview = async (id) => request(`/api/admin/reviews/${id}`, { method: "DELETE", auth: true });
